import { CrmPage } from "constants/crmPages";
import { useConstructInternalLink } from "hooks/useConstructInternalLink";

type ConstructInternalLink = ReturnType<
  typeof useConstructInternalLink
>["link"];

type CrmTabState = {
  to: string;
  toPath: string;
  isSelected: boolean;
};

export const getCrmTabState = ({
  tab,
  url,
  pathname,
  link,
}: {
  tab: Pick<
    CrmPage,
    "url" | "exact" | "omitUrl" | "activeBasePath" | "extraActivePaths"
  >;
  url: string;
  pathname: string;
  link: ConstructInternalLink;
}): CrmTabState => {
  const [tabPath, tabSearch] = tab.url.split("?");
  const tabQuery = Object.fromEntries(new URLSearchParams(tabSearch));

  const to = link(tabPath, { includeUrl: !tab.omitUrl, moreQuery: tabQuery });
  const toPath = to.split("?")[0];

  const matchesExtraActivePath = Boolean(
    tab.extraActivePaths?.some((p) => pathname.includes(`${url}${p}`))
  );

  let isSelected = pathname.startsWith(toPath);
  if (tab.activeBasePath) {
    isSelected = pathname.startsWith(`${url}${tab.activeBasePath}`);
  }
  if (tab.exact && !tab.activeBasePath) isSelected = pathname === toPath;
  if (matchesExtraActivePath) isSelected = true;

  return { to, toPath, isSelected };
};
